import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { FAQ_API_URLS } from './apiUrlConstants';

const _httpService = new HttpService();

// Set base URL at request time (not module load time) to ensure sessionStorage is populated
const setBaseUrl = () => {
  if (checkIsInternal()) {
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
  } else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
  }
};

export const fetchFaqData = async () => {
  setBaseUrl();
  try {
    const response = await _httpService.get(FAQ_API_URLS.FETCH_FAQ_LIST) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to fetch FAQ list data');
    }
    return response;
  } catch (error) {
    console.error('Error fetching FAQ data:', error);
    throw error;
  }
};

export const fetchFaqCategories = async () => {
  setBaseUrl();
  try {
    const response = await _httpService.get(FAQ_API_URLS.FETCH_FAQ_CATEGORIES) as any;
    if (response.StatusCode !== 200) {
      throw new Error(response.Message || 'Failed to fetch FAQ categories');
    }
    return response;
  } catch (error) {
    console.error('Error fetching FAQ categories:', error);
    throw error;
  }
};

export const saveFaqFormData = async (payload: any) => {
  setBaseUrl();
  const saveData = async () => {
    try {
      const response = (await _httpService.push(
        FAQ_API_URLS.SAVE_FAQ,
        payload
      )) as {
        data: any;
      };
      return response;
    } catch (error) {
      throw error;
    }
  };
  return saveData();
};

export const fetchFaqListData = async () => {
  setBaseUrl();
  const fetchData = async () => {
    try {
      const response = (await _httpService.get(
        FAQ_API_URLS.FETCH_FAQ_LIST
      )) as {
        data: any;
      };
      return response;
    } catch (error) {
      throw error;
    }
  };
  return fetchData();
};

export const deleteFaq = async (payload: any) => {
  setBaseUrl();
  try {
    const response = (await _httpService.push(
      FAQ_API_URLS.DELETE_FAQ(payload),
      {}
    )) as { data: any };
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchSingleFaqData = async (payload: any) => {
  setBaseUrl();
  const fetchData = async () => {
    try {
      const response = (await _httpService.get(
        FAQ_API_URLS.FETCH_SINGLE_FAQ(payload)
      )) as {
        Data: any[];
      };
      return response;
    } catch (error) {
      throw error;
    }
  };
  return fetchData();
};
